module.exports = __webpack_public_path__ + "img/ic-in.3ddc352f.svg";